module.exports = __webpack_public_path__ + "media/images/s_BBD1B69AD25C70A586F14D4D390FE143644DA806650EAB8265640B2B0CCBF7C2_1711036405718_Ivan_McClellan_09.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/s_BBD1B69AD25C70A586F14D4D390FE143644DA806650EAB8265640B2B0CCBF7C2_1711036405718_Ivan_McClellan_09.jpg
// module id = 42
// module chunks = 0